<template lang="pug">
	div.settings-control(:class="setting.codename" v-if="Version.SelectedVersion")
		hr(v-if="setting.options.separator")

		.clearfix.mt-4.control-box
			.controls(v-show="checkHidden(setting)" v-if="setting['title']")
				.controls-title {{setting["title"]}}
				i.icon-info.icons.font-2xl(v-if="setting['description']" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: setting['description']}")
				i.icon-revert.fa.fa-rotate-left(v-if="Settings.isSettingValueChanged(Version.SelectedVersion.id, setting.codename)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Revert changes to default'}" v-on:click="revertSettingValue(Version.SelectedVersion.id, setting.codename)")
			.value
				.value-range(v-show="checkHidden(setting)" v-if="setting.control === 'range'")
					input.form-control.form-control-sm.hidden(type="text" :value="(value / multiplier).toFixed(2).replace(/[.,]00$/, \"\") + (setting.options.units || '')" v-on:change="Settings.setSettingValueSafe(setting.codename, $event.target.value)" v-on:input="Settings.setSettingValueSafe(setting.codename, $event.target.value)")

			span(v-show="checkHidden(setting)" v-if="setting.control === 'switch' && !checkDisabled(setting)")
				.switch-control
					label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
						input.switch-input.form-check-input(type="checkbox" :checked="value" v-on:change="Settings.setSettingValue(setting.codename, $event.target.checked)")
						span.switch-slider(data-checked="On" data-unchecked="Off")
						span.switch-handle

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'select' && !checkDisabled(setting)")
				select.custom-select.custom-select-sm(:name="setting.codename" v-on:change="Settings.setSettingValue(setting.codename, $event.target.value)")
					option(v-if="!setting.options.removeRandomValue" :selected="value === '#random'" value="#random") {{(setting.options['optionDescriptions'] && setting.options['optionDescriptions']['#random']) ? setting.options['optionDescriptions']['#random'] : '(use random value)'}}
					option(v-for="v in setting.options.values" :selected="v === value" :value="v") {{(setting.options['optionDescriptions'] && setting.options['optionDescriptions'][v]) ? setting.options['optionDescriptions'][v] : v}}

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'radio'")
				label.form-check.radio(v-if="!setting.options.removeRandomValue")
					input.form-check-input(:name="setting.codename" :checked="value === '#random'" :disabled="checkDisabled(setting)" type="radio" v-on:change="Settings.setSettingValue(setting.codename, '#random')")
					span {{(setting.options['optionDescriptions'] && setting.options['optionDescriptions']['#random']) ? setting.options['optionDescriptions']['#random'] : '(use random value)'}}
				label.form-check.radio(v-for="v in setting.options.values")
					input.form-check-input(:name="setting.codename" :checked="v === value" :disabled="checkDisabled(setting)" type="radio" v-on:change="Settings.setSettingValue(setting.codename, v)")
					span {{(setting.options['optionDescriptions'] && setting.options['optionDescriptions'][v]) ? setting.options['optionDescriptions'][v] : v}}

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'range'")
				div.range-control
					input.custom-range(type="range" :min="setting.options.min" :max="setting.options.max" :step="setting.options.step" :value="value" :disabled="checkDisabled(setting)" v-on:input="Settings.setSettingValue(setting.codename, $event.target.value)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: (setting.options.min / multiplier) + units + ' - ' + (setting.options.max / multiplier) + units}")

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'range-chances' && !checkDisabled(setting)")
				div.range-values-control(v-for="(v, index) in value")
					div
						small.text-muted Chance of {{setting.options.chanceNames[index]}} piece: {{v / multiplier + units}}
					input.custom-range(type="range" :min="setting.options.min" :max="setting.options.max" :step="setting.options.step" :value="v" :disabled="checkDisabled(setting)" v-on:input="Settings.setRangeChancesSettingValue(setting.codename, $event.target.value, index, setting.options.max)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: (setting.options.min / multiplier) + units + ' - ' + (setting.options.max / multiplier) + units}")

			span(v-show="checkHidden(setting)" v-else-if="(setting.control === 'input' || setting.control === 'color') && !checkDisabled(setting)")
				span(v-if="setting.options.split" :class="setting.control + '-control'")
					span.split-input(v-for="(control, index) in setting.options.split")
						span(v-if="control.name").split-title.text-muted {{control.name}}
						span(v-else).split-title.text-muted {{index}}
						input.form-control.form-control-sm(:type="(setting.control === 'input' || setting.control === 'text') ? 'text' : setting.control" :value="value ? value[index] : ''" :placeholder="control.placeholder" v-on:input="Settings.setSettingValue(setting.codename, $event.target.value, index)")
				span(v-else :class="setting.control + '-control'")
					input.form-control.form-control-sm(ref="textInput" :type="(setting.control === 'input' || setting.control === 'text') ? 'text' : setting.control" :value="value" :placeholder="setting.options.placeholder" v-on:input="Settings.setSettingValue(setting.codename, $event.target.value)")

			span(v-show="checkHidden(setting)" v-else-if="(setting.control === 'textarea') && !checkDisabled(setting)")
				textarea.form-control.form-control-sm(:value="value" :placeholder="setting.options.placeholder" v-on:change="Settings.setSettingValue(setting.codename, $event.target.value)" :rows="setting.options.rows || 3")

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'checkbox' && !checkDisabled(setting)")
				.multi-select-checkboxes
					.multi-select-checkbox.form-check.checkbox(v-for="v in setting.options.values" :checked="v === value" :value="v")
						label.form-check-label
							input.form-check-input(type="checkbox" :checked="value && value.includes(v)" v-on:change="Settings.setMultiSelectSettingValue(setting.codename, v, $event.target.checked)")
							|{{(setting.options['optionDescriptions'] && setting.options['optionDescriptions'][v]) ? setting.options['optionDescriptions'][v] : v}}

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'css' && !isAllCssPropertiesMuted(value) && !checkDisabled(setting)")
				span.split-input.css-property(v-for="(propertyValue, propertyName) in value")
					span.split-title.text-muted(v-if="!isMutedCssProperty(propertyName, propertyValue) && isToShowCssProperty(propertyName, setting)") {{getCSSPropTitle(propertyName)}}
					span(v-if="cssListProps.indexOf(propertyName) !== -1 && isToShowCssProperty(propertyName, setting)")
						SettingCssList(v-if="!isMutedCssProperty(propertyName, propertyValue) && isToShowCssProperty(propertyName, setting)" :settingName="setting.codename" :propertyName="propertyName" :startValue="propertyValue")
					span(v-else-if="propertyName === 'opacity' && isToShowCssProperty(propertyName, setting)")
						input.form-control.form-control-sm.form-control-w.custom-range(type="range" :value="parseFloat(propertyValue) * 100" v-on:change="Settings.setCSSSettingValue(setting.codename, propertyName, (parseInt($event.target.value) / 100) + '')")
					span(v-else-if="_.includes(['trailColor', 'color', 'borderColor', 'backgroundColor', 'fill'], propertyName) && isToShowCssProperty(propertyName, setting)")
						input.form-control.form-control-sm.form-control-w(type="color" :value="propertyValue" v-on:change="Settings.setCSSSettingValue(setting.codename, propertyName, $event.target.value)")
					span(v-else-if="propertyName === 'boxShadow' && isToShowCssProperty(propertyName, setting)" data-style="box-shadow")
						span.form-control-bs-cont.form-control-w(data-cont)
							input.form-control.form-control-sm(type="text" :value="getBoxShadowParam(propertyValue)" v-on:change="combineCompoundParams(setting.codename, propertyName, $event)")
							input.form-control.form-control-sm(type="color" :value="getBoxShadowParam(propertyValue, 'color')" v-on:change="combineCompoundParams(setting.codename, propertyName, $event)")
					span(v-else-if="propertyName === 'border' && isToShowCssProperty(propertyName, setting)" data-style="border")
						span.form-control-bs-cont.form-control-w(data-cont)
							input.form-control.form-control-sm(type="text" :value="getBorderParam(propertyValue, 'width')" v-on:change="combineCompoundParams(setting.codename, propertyName, $event)")
							input.form-control.form-control-sm(type="text" :value="getBorderParam(propertyValue, 'style')" v-on:change="combineCompoundParams(setting.codename, propertyName, $event)")
							input.form-control.form-control-sm(type="color" :value="getBorderParam(propertyValue, 'color')" v-on:change="combineCompoundParams(setting.codename, propertyName, $event)")
					span(v-else-if="isToShowCssProperty(propertyName, setting)")
						input.form-control.form-control-sm.form-control-w(v-if="!isMutedCssProperty(propertyName, propertyValue)" type="text" :value="propertyValue" v-on:change="Settings.setCSSSettingValue(setting.codename, propertyName, $event.target.value)")

			span(v-show="checkHidden(setting)" v-else-if="(setting.control === 'json')")
				JsonEditControl(:setting="setting")

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'double-drag-list'")
				DoubleDragListControl(:setting="setting")

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'double-drag-list-pieces'")
				span(v-for="(level, levelId) in Settings.getSettingValue('levels-list')")
					div.clearfix.mt-4
						span Level {{levelId + 1}}
					DoubleDragListControl(:setting="setting" :id="levelId")

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'list'")
				ListControl(:setting="setting")

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'button' && !checkDisabled(setting)")
				input.form-control.form-control-sm(type="button" :value="setting.title" v-on:click="Settings.setSettingValue(setting.codename, $event.target.value)")

			span(v-show="checkHidden(setting)" v-else-if="setting.control === 'asset-link' && !checkDisabled(setting)")
				AssetLinkControl(:setting="setting")

			span(v-show="checkHidden(setting)" v-else-if="setting['control'] === 'custom' && !checkDisabled(setting)")
				component(:is="setting.options.componentName" :setting="setting")

</template>

<script>

	import changeCase 				from "change-case";

	import Screen 					from './../../mixins/screen';

	import { Project } 				from './../../services/Project'
	import { Version } 				from './../../services/Version'
	import { Settings } 			from './../../services/Settings'

	import AssetLinkControl 		from './CustomControls/AssetLinkControl'
	import SettingCssList 			from './CustomControls/SettingCssList'
	import DoubleDragListControl 	from './CustomControls/DoubleDragListControl'
	import JsonEditControl 			from './CustomControls/JsonEditControl'
	import ListControl 				from './CustomControls/ListControl'
	import TrackUrlActions 			from './CustomControls/TrackUrlActions'
	import TrackUrlGlobalExclude	from './CustomControls/TrackUrlGlobalExclude'
	import TrackingProviders		from './CustomControls/TrackingProviders'
	import TrackingEventsSettings	from './CustomControls/TrackingEventsSettings'
	import TrackRatingKey			from './CustomControls/TrackRatingKey'
	import EndCardControl 			from './CustomControls/EndCardControl'
	import ProductFeed 				from './CustomControls/ProductFeed'

	export default {
		name: 'SettingControls',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Selected Version Settings Loaded", "Selected Version Settings Original Loaded"]
		},
		props: ['setting', 'section'],
		components: {
			AssetLinkControl,
			SettingCssList,
			DoubleDragListControl,
			JsonEditControl,
			ListControl,
			TrackUrlActions,
			TrackUrlGlobalExclude,
			TrackingProviders,
			TrackingEventsSettings,
			TrackRatingKey,
			EndCardControl,
			ProductFeed
		},
		data() {

			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			this.changeCase = changeCase;

			this.document = window.document;
			this.value = null;

			this.cssListProps = ['fontFamily', 'fontWeight', 'fontStyle', 'cursor', 'textAlign'];

			return {
				showed: true,
				multiplier: this.setting.options.unitsMultiplier || this.setting.options.multiplier || 1,
				precision: this.setting.options.precision || 2,
				units: this.setting.options.units || ''
			};

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии проекта
			this.addUpdateEvent(`Selected Version Setting Changed:${this.setting.codename}`);

			if (this.setting.options?.dependency && ("name" in this.setting.options?.dependency)) this.addUpdateEvent(`Selected Version Setting Changed:${this.setting.options.dependency.name}`);

		},
		watch: {
			setting(newVal, oldVal) {
				this.setting = newVal;
				this.collectData();
			}
		},
		methods: {

			collectData(...params) {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return;

				this.value = Settings.getSettingValue(this.setting.codename);

				if (params[0] === `Selected Version Setting Changed:${this.setting.codename}` && document.activeElement === this.$refs.textInput) {
					this.value = this.$refs.textInput.value;
				}

				if (this.setting.control === 'color') {

					if (this.value && this.value.indexOf('0x') === 0) this.value = this.value.replace('0x', '#');

				}

			},

			revertSettingValue(versionId, settingCodename) {

				Settings.revertSettingValue(versionId, settingCodename);

			},

			checkDisabled(setting) {

				if (setting.options.disabled) return true;

				if (setting.options.dependency && ("value" in setting.options.dependency)) return Settings.getSettingValue(setting.options.dependency.name) !== setting.options.dependency.value;

				if (setting.options.dependency && ("values" in setting.options.dependency)) return !_.includes(setting.options.dependency.values, Settings.getSettingValue(setting.options.dependency.name));

				return false;

			},

			checkHidden(setting) {

				if (setting.options.hidden) return false;

				if (setting.options.dependency && ("method" in setting.options.dependency) && setting.options.dependency['method'] === 'display') {

					//console.log(Settings.getSettingValue(setting.options.dependency.name) !== setting.options.dependency.value, !_.includes(setting.options.dependency.values, Settings.getSettingValue(setting.options.dependency.name));

					if (setting.options.dependency && ("value" in setting.options.dependency)) return Settings.getSettingValue(setting.options.dependency.name) === setting.options.dependency.value;
					else if (setting.options.dependency && ("values" in setting.options.dependency)) return _.includes(setting.options.dependency.values, Settings.getSettingValue(setting.options.dependency.name));
					//else if (setting.options.dependency && ("innerPropertyName" in setting.options.dependency)) return Settings.getSettingValue(setting.options.dependency.name)?.[setting.options.dependency["innerPropertyName"]]?.[setting.options.dependency["innerPropertyValue"]];

				}

				return true;

			},

			isMutedCssProperty(name, value) {

				return name === 'display'/* && value === 'none'*/;

			},

            isToShowCssProperty(name, setting) {

			    let isPropToShow = false;

			    if (setting && setting.options && setting.options.cssPropsToShow){

                    setting.options.cssPropsToShow.forEach(propName => {
                    	//.split(':') отделяет :portrait :landscape варианты стилей
                    	if (name && name.split && name.split(':')[0] === propName.split(':')[0]) isPropToShow = true;
					});

				} else {
                    isPropToShow = true;
				}

			    return isPropToShow;

            },

			isAllCssPropertiesMuted(properties) {

				for (let name in properties) {

					if (properties.hasOwnProperty(name) && !this.isMutedCssProperty(name, properties[name])) return false;

				}

				return true;

			},

			getCSSPropTitle(propertyName) {

				if (!propertyName || !propertyName.indexOf) {

					console.log('getCSSPropTitle error:', propertyName);

					return '';

				}

				let is_landscape = propertyName.indexOf(':landscape') > 0;
				let is_portrait = propertyName.indexOf(':portrait') > 0;

				let title = changeCase.titleCase(propertyName.split(':')[0]);

				if (is_landscape) title += ' L';
				if (is_portrait) title += ' P';

				return title;

			},

			getBorderParam(styleStr, paramName) {
				let result = styleStr.match(/rgba?\((\d+\,?\s*)+\)|#[0-9abcdef]+/ig);
				styleStr = styleStr.replace(result, '');

				if (paramName === 'width') {
					result = styleStr.match(/\d+[A-Za-z]{2}/ig);
				} else if (paramName === 'style') {
					result = styleStr.match(/[A-Za-z]{3,}/ig);
				}

				result = result && result.length > 0 ? result[0] : styleStr;

				return result;
			},

			getBoxShadowParam(styleStr, paramName) {
				let result = styleStr.match(/rgba?\((\d+\,?\s*)+\)|#[0-9abcdef]+/ig);
				styleStr = styleStr.replace(result, '');

				if (paramName !== 'color') {
					result = styleStr.match(/((\d+)[a-z]*\s+)+/ig);
				}

				result = result && result.length > 0 ? result[0] : styleStr;

				return result;
			},

			combineCompoundParams(settingName, propertyName, el) {
				let element = el.target;

				for (let i = 0; i < 10; i++) {
					if (!element.parentNode) break;

					if (element.hasAttribute('data-style')) break;

					element = element.parentNode;
				}

				let styleResult = '';

				const getInputVal = (node, res = '') => {
					if (node.nodeName !== 'INPUT' && node.childNodes.length > 0) {
						for (let i = 0; i < node.childNodes.length; i++) {
							res = getInputVal(node.childNodes[i], res);
						}
					} else {
						res += node.value + ' ';
					}

					return res;
				};

				for (let i = 0; i < element.childNodes.length; i++) {
					styleResult = styleResult === '' ? getInputVal(element.childNodes[i]) : ', ' + getInputVal(element.childNodes[i]);
				}

				Settings.setCSSSettingValue(settingName, propertyName, styleResult);
			}
		}
	}
</script>

<style lang="sass">

	aside.aside-menu
		background-color: #3a4149
		border-left: 1px solid #23282c
		color: #f3f4f5
		cursor: default

		hr
			color: #23282c
			border-top-color: #23282c
			margin-left: -1rem
			margin-right: -1rem
			margin-bottom: -0.5rem

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

		.settings-control
			font-size: 0.875rem

			.switch-control
				position: absolute
				right: 0
				top: 0

			.color-control
				position: absolute
				right: 0
				top: -6px

				input
					width: 100px

			.range-control
				display: flex
				flex-direction: column

			.range-values-control
				display: flex
				justify-content: space-between
				user-select: none

			.asset-link-control
				position: absolute
				right: 0
				top: -8px

			select
				width: auto
				float: left
				margin-top: 5px

			label.form-check.radio
				line-height: 24px
				margin: 0

			.form-check
				cursor: pointer
				font-size: 80%

				input
					cursor: pointer

			input.form-control.form-control-sm
				margin-top: 2px
				border: 1px solid #23282c
				background-color: #515b65
				background-clip: padding-box
				height: calc(1.5em + 0.5rem + 3px)
				color: #e4e7ea

				&::placeholder
					color: rgba(255, 255, 255, 0.1)

				&.hidden
					display: inline-block
					box-shadow: none
					border: none
					background-color: transparent
					font-size: inherit
					color: inherit
					width: 70px
					margin: 0
					padding: 0 10px
					text-align: right
					height: auto
					transform: translateX(10px)

			.form-control-bs-cont
				display: flex

				input[type="color"]
					width: 40px
					min-width: 40px

			.multi-select-checkboxes

				.multi-select-checkbox
					margin-top: 5px

					.form-check-input
						position: absolute
						margin-top: 0.1rem
						margin-left: -1.25rem

			.split-input
				display: flex
				white-space: nowrap
				line-height: 30px

				.split-title
					margin-top: 2px
					align-items: center
					padding: .25rem .75rem 0 .75rem
					margin-bottom: 0
					font-size: .875rem
					font-weight: 400
					line-height: 1.5
					color: #e4e7ea
					text-align: center
					white-space: nowrap
					margin-right: -1px
					background-color: #343b41
					background-clip: border-box
					border: 1px solid #23282c
					border-top-left-radius: .25rem
					border-bottom-left-radius: .25rem

				input
					border-top-left-radius: 0
					border-bottom-left-radius: 0

			.split-input.css-property

				.split-title
					width: 250px
					text-align: right
					font-size: .65rem
					line-height: 20px

				input.form-control.form-control-sm
					/*width: 200px*/

			.control-box
				position: relative

				.controls
					display: flex
					flex-direction: row
					align-items: center

					.controls-title
						max-width: 250px
						white-space: nowrap
						text-overflow: ellipsis
						overflow: hidden

					.icon-info
						color: #20a8d8
						font-size: 0.7rem !important
						display: inline-block
						margin-left: 7px
						cursor: help

					.icon-revert
						display: flex
						align-items: center
						justify-content: center
						width: 21px
						height: 21px
						margin: 0px 2px
						cursor: pointer
						font-size: 0.7rem

						&:hover
							color: #20a8d8

				.value
					position: absolute
					right: 0
					top: 0
					display: flex
					flex-direction: row

		.form-control-w
			width: 200px

</style>
